import {Component, inject} from '@angular/core';
import {SidebarService} from '../../services/sidebar.service';
import {AsyncPipe, NgClass} from '@angular/common';
import {Router, RouterOutlet} from '@angular/router';
import {AppSidebar} from '../app-sidebar/app-sidebar';
import {BackdropComponent} from '../backdrop/backdrop.component';
import {AppHeaderComponent} from '../app-header/app-header.component';
import {AppFooter} from '../app-footer/app-footer';

@Component({
  selector: 'app-layout',
  imports: [
    AsyncPipe,
    NgClass,
    RouterOutlet,
    AppSidebar,
    BackdropComponent,
    AppHeaderComponent,
    AppFooter
  ],
  templateUrl: './app-layout.html'
})
export class AppLayout {
  private sidebarService = inject(SidebarService);
  private router = inject(Router);

  readonly isExpanded$ = this.sidebarService.isExpanded$;
  readonly isMobileOpen$ = this.sidebarService.isMobileOpen$;

  get isFullWidthPage(): boolean {
    let route = this.router.routerState.snapshot.root;
    while (route) {
      if (route.data['fullWidth'] === true) return true;
      if (!route.firstChild) break;
      route = route.firstChild;
    }
    return false;
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      this.isExpanded$ ? 'xl:ml-[290px]' : 'xl:ml-[90px]',
      this.isMobileOpen$ ? 'ml-0' : ''
    ];
  }
}
